export default class Price {
  constructor() {
    this.$price = document.querySelector('[data-price]')
    if(!this.$price) return;
    this.$box = [...document.querySelectorAll('[data-price-el="box"]')]
    this.$img = [...document.querySelectorAll('[data-price-el="img"]')]
    this.$people = [...document.querySelectorAll('[data-price-el="person"]')]
    this.init();
  }

  init() {
    this.setup();
    this.animate();
  }

  setup() {
    gsap.set(this.$box, { autoAlpha: 0, yPercent: (index) => index % 2 === 0 ? -40 : 40 })
    gsap.set(this.$img, { autoAlpha: 0, scale: 1.1 })
    gsap.set(this.$people, { autoAlpha: 0, yPercent: -25 })
  }

  animate() {
    const animateTl = gsap.timeline();
    ScrollTrigger.create({
      trigger: this.$price,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        animateTl
          .to(this.$img, {
            autoAlpha: 1,
            scale: 1,
            duration: 0.8,
            ease: 'power1.in',
            stagger: { 
              each: 0.2,
            },
          })
          .to(this.$box, {
            autoAlpha: 1,
            yPercent: 0,
            duration: 0.8,
            ease: 'expo.out',
            stagger: { 
              each: 0.2,
            },
          }, '<')
          .to(this.$people, {
            autoAlpha: 1,
            yPercent: 0,
            duration: 1.0,
            ease: 'expo.out',
            stagger: { 
              each: 0.2,
            },
          },'-=0.2')
      }
    });
  }
}
